var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecureCohort = function SvgSecureCohort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 68 67"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.16,
    cy: 33.396,
    r: 33.26,
    fill: "#204969"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFF4",
    d: "M45.694 24.569c-6.332-.82-9.95-4.631-10.092-4.777a1.65 1.65 0 0 0-1.328-.528c-.396.03-.763.234-1.046.527-.028.03-3.647 3.928-10.063 4.778a1.725 1.725 0 0 0-1.47 1.847c1.046 15.094 11.59 20.311 12.042 20.516.226.117.452.147.678.147s.48-.059.678-.147c.453-.205 10.996-5.422 12.042-20.546.057-.88-.593-1.7-1.441-1.817M39.023 36.82c0 .704-.566 1.29-1.244 1.29h-6.756c-.678 0-1.244-.586-1.244-1.29V32.22c0-.704.566-1.29 1.244-1.29h.368v-2.022c0-1.73 1.356-3.107 2.996-3.107s2.996 1.407 2.996 3.107v2.022h.424c.678 0 1.244.586 1.244 1.29v4.601z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFF4",
    d: "M36.111 28.936c0-.967-.763-1.759-1.696-1.759s-1.696.792-1.696 1.76v2.021h3.392zM35.49 33.069l-1.414 1.465-.707-.733a.65.65 0 0 0-.932 0 .66.66 0 0 0 0 .968l1.187 1.23a.6.6 0 0 0 .452.206c.17 0 .34-.059.452-.205l1.866-1.935a.71.71 0 0 0 0-.967.595.595 0 0 0-.905-.03"
  })));
};
export default SvgSecureCohort;